/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useRef, useEffect, useMemo } from "react";

import moment from "moment-timezone";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
//Backend access
import { loadToken, getCameraHistory } from 'api/bks';
import PropTypes from "prop-types";
import bksAPI from 'api/bks';
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { PacmanLoader } from "react-spinners";
import CameraSelects from "nextus/Charts/Selectors/Camera";
import { Chart as Chartjs, registerables } from 'chart.js';
import zoomPlugin from "chartjs-plugin-zoom";
import CameraFeedChart from "nextus/Charts/CameraFeedChart";
import { useQuery } from "@tanstack/react-query";

Chartjs.register(...registerables);
Chartjs.register(zoomPlugin); // REGISTER PLUGIN

function wrapper(content) {
  return (
    <SoftBox p={2}>
      {content}
    </SoftBox>
  )
}

// Images
function CameraFeed({ uuid }) {

  const [endTime, setEndTime] = useState(moment());
  const [startTime, setStartTime] = useState(moment().subtract(1, 'day'));
  const [chartData, setChartData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const setLimits = true;

  bksAPI.loadToken(useAuth0());

  const currentCameraImage = useQuery({
    queryKey: ['getCameraFeed', uuid],
    queryFn: async () => {
      return await bksAPI.getCameraFeed(uuid);
    }
  });

  useEffect(() => {
    async function getHistory() {
      // console.log(startTime.unix(), endTime.unix());
      var data = await getCameraHistory(uuid, startTime.unix(), endTime.unix(), true);
      // console.log(data);
      setChartData(data);
      setIsLoading(false);
    }
    getHistory();
  }, [startTime, endTime]);

  if (currentCameraImage.isLoading) {
    return wrapper("Loading...");
  }

  if (currentCameraImage.error) {
    return wrapper("Error! " + currentCameraImage.error.message);
  }

  const blob = new Blob([currentCameraImage.data]);
  const current_camera_url = URL.createObjectURL(blob);

  return (
    wrapper(<>
      <CameraSelects {...{ startTime, setStartTime, endTime, setEndTime, setLimits }} />
      <CameraFeedChart {...{ uuid, startTime, endTime, setStartTime, setEndTime, chartData, isLoading, setIsLoading, current_camera_url }} />
    </>)
  );
}

// Typechecking props for the CameraFeed
CameraFeed.propTypes = {
  uuid: PropTypes.string
};


export default CameraFeed;
